import { VehicleContext } from "context/vehicleContext";
import { FC, useContext, useEffect, useState } from "react";
import InputRange from "react-input-range";

interface MultiRangeSliderProps {
  minVal: number;
  maxVal: number;
  onChange: ({ min, max }: { min: number; max: number }) => void;
  onSetLabel: ({ min, max }: { min: number; max: number }) => void;
  typeName: string;
  step: number;
}

const ReactInputSimpleSlider: FC<MultiRangeSliderProps> = ({
    maxVal,
    onChange,
    onSetLabel,
    typeName,
    step,
}) => {
    const [record, setRecord] = useState(maxVal ?? 1,);

    const { filtersFromUrl } = useContext(VehicleContext);


    useEffect(() => {
        if (
            filtersFromUrl?.[typeName]?.isFiltered &&
            filtersFromUrl?.[typeName]?.values?.filter((c: string) => c !== "").length > 0
        ) {
            const valuesFromParameters = filtersFromUrl?.[typeName]?.values;

            const maxSelected = Number(valuesFromParameters?.[1] ?? 1);

            setRecord(maxSelected);
            onSetLabel({
                min: 0,
                max: maxSelected,
            });
            // }
        } else {
            setRecord(maxVal);
            onSetLabel({
                min: 0,
                max: maxVal,
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [maxVal, filtersFromUrl?.[typeName]?.isFiltered]);

    const newValues = record > maxVal ? maxVal : record;

    return (
        <div className={`container-slider cls-${typeName}`}>
            <InputRange
                maxValue={maxVal}                
                minValue={0}
                value={newValues}
                step={step}
                ariaLabelledby={typeName}
                onChange={(value: any) => {
                    setRecord(value);
                    onSetLabel({
                        min: 0,
                        max: value,
                    });
                }}
                onChangeComplete={(value: any) => {
                    onChange({
                        min: 0,
                        max: value,
                    });
                }}
            />
        </div>
    );
};

export default ReactInputSimpleSlider;
